import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=937a40fc&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
import style0 from "./Order.vue?vue&type=style&index=0&id=937a40fc&prod&lang=scss"
import style1 from "./Order.vue?vue&type=style&index=1&id=937a40fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937a40fc",
  null
  
)

export default component.exports